<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1,1,1)" label-width="80px" @submit.native.prevent>
            <el-form-item label="关键字" prop="name">
                <el-input v-model.trim="searchForm.name" maxlength="20"
                          placeholder="请输入关键字(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1,1,1)" size="small" icon="el-icon-search">查询
                </el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-if="hasPermission('sys:process:processList:addData')"
                           @click="addData('add')" type="primary" icon="el-icon-plus"
                           size="small">新增
                </el-button>
                <el-button v-if="hasPermission('sys:process:processList:deleteData')"
                           @click="deleteData()" type="danger" icon="el-icon-delete"
                           size="small">批量删除
                </el-button>
            </el-form-item>
        </el-form>
        <div class="tips"><el-link class="el-icon-info" type="primary" :underline="false"></el-link>已选择{{dataListSelect.length}}项数据</div>
        <el-table
                :data="dataList"
                v-loading="loading"
                size="small" height="100%"
                class="table" border
                ref="multipleTable"
                :row-key="'id'"
                @sort-change="sortChange"
                @selection-change="selectionChangeHandle"
        >
            <el-table-column :reserve-selection="true" type="selection" width="50"/>
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="flowName" label="流程名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" width="100px" label="状态" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <el-switch
                        v-model="row.status"
                        active-value="0"
                        @change="setType(row)"
                        inactive-value="1">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="flowExplain" label="流程说明" show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateByName" label="最新修改人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateTime" sortable="custom" label="最新修改时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createByName" label="创建人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" sortable="custom" label="创建时间" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" min-width="100px" label="操作">
                <template slot-scope="{row}">
                    <el-button v-if="hasPermission(`sys:process:processList:edit`)" type="text" size="small" @click="addData('edit',row)">编辑</el-button>
                    <el-button v-if="hasPermission(`sys:process:processList:deleteData`)" type="text" size="small" @click="deleteData(row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <add-process ref="addProcess" @refresh="refreshList(1,1)"></add-process>
    </div>
</template>

<script>
import AddProcess from "@/views/modules/sys/process/addProcess.vue";

export default {
    name: "processList",
    components: {AddProcess},
    data() {
        return {
            searchForm: {
                name: '',
                current: 1,
                size: 20,
            },
            total: 0,
            applicantList:[],

            sort:'',
            loading: false,
            dataList: [{}],
            dataListSelect: [],
        }
    },

    mounted() {
        this.refreshList()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect, sort) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (sort) {
                this.$refs.multipleTable.clearSort()
            }
            this.loading = true
            this.$axios(this.api.dyygRelease.releasesFlowList, {
                ...this.searchForm,
                sort:this.sort,
            }).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1, 1)
        },

        // 列表排序
        sortChange(column, type) {
            this.sort = ''
            if (column.order){
                if (column.prop == 'updateTime') {
                    this.sort = 'update_time ' + (column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : ''))
                }
                if (column.prop == 'createTime') {
                    this.sort = 'create_time ' + (column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : ''))
                }
            }
            this.refreshList(1, 1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        //切换状态
        setType(row) {
            row.status = row.status == 1 ? 0 : 1
            this.$axios(this.api.dyygRelease.releasesFlowEnableOrDisable, {
                id:row.id,
                status:row.status == 1 ? 0 : 1,
            }, 'put').then(data => {
                if (data && data.status) {
                    this.$message.success('状态修改成功')
                    this.refreshList()
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //typeName edit编辑 add新增
        addData(typeName,row){
            this.$refs.addProcess.init(typeName,row)
        },

        //删除
        deleteData(row){
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let statusTrueList = []
            let ids = list.map(item => {
                if (item.status == 0){
                    statusTrueList.push(item)
                }
                return item.id
            })
            if (statusTrueList.length != 0) {
                this.$message.warning('请先禁用后再删除！')
                return
            }
            this.$confirm(`确认删除所选信息？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.dyygRelease.releasesFlowRemoveByIds, ids, 'post').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },





    }
}
</script>

<style scoped>
.tips {
    padding: 4px;
    .el-icon-info {
        margin-right: 6px;
    }
}
</style>